import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/team-effectiveness/team-effectiveness-model-logo.png'


const _hoisted_1 = {
  key: 0,
  class: "team-effectiveness-report team-theme",
  "data-test": "team-effectiveness-report"
}
const _hoisted_2 = {
  key: 0,
  class: "container text-center",
  style: {"margin-top":"20px"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "container maxWidth-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_6 = { class: "title-container" }
const _hoisted_7 = { class: "title-text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" }, null, -1)
const _hoisted_10 = { class: "report-subtitle" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-2 col-sm-offset-5 text-center",
    style: {"padding-top":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img-responsive",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-12 text-center" }
const _hoisted_15 = { style: {"margin-left":"5px","margin-right":"5px"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"20px 0"} }, "Click the button below to complete the Questionnaire.", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-12 text-center" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-6 col-sm-offset-3 text-center",
    style: {"margin-top":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, " If you’d like to complete a Team Effectiveness Questionnaire on a different team, close this session and select another team or create a new one from the top of the page. ")
  ])
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-2 col-sm-offset-5 text-center",
    style: {"padding-top":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img-responsive",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-12 text-center" }
const _hoisted_24 = { style: {"margin-left":"5px","margin-right":"5px"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"20px 0"} }, " Click the button below to access the Team Effectiveness Review page and start a new review. ", -1)
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-12 text-center" }
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-6 col-sm-offset-3 text-center",
    style: {"margin-top":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, " If you’d like to complete a Team Effectiveness Questionnaire on a different team, close this session and select another team or create a new one from the top of the page. ")
  ])
], -1)

import axios from "axios";
import moment from "dayjs";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { CmsDocumentTypes, CmsResourceData } from "../../services/cms/cms-type-definitions";
import CmsTextPage from "../cms/cms-text-page.vue";
import cmsContentMap from "../../services/cms/cms-content-map";
import {
  TeamApiModel,
  ReportSharingTypeApiModel,
  TeamEffectivenessReviewApiModel,
} from "../../api-models";
import { CmsReport } from "../../services/cms/types/cms-report";
import ShareButton from "../../components/share-button.vue";
import cms from "../../services/cms/cms";
import {
  getTeamEffectivenessReportFlexible,
  getTeamEffectivenessReportTeamId,
  getTeamEffectivenessReportReviewId,
} from "../../components/team-effectiveness/get-team-effectiveness-report-team-id";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-report',
  props: {
    doc: {}
  },
  setup(__props: any) {

const needsToCompleteQuestionnaireFirst = ref(false);
const needsToStartReviewFirst = ref(false);
const showReport = ref(false);
const isLoaded = ref(false);
const reportDoc = ref<CmsReport | null>(null);
const error = ref("");
const newReviewTeamDetails = ref<TeamApiModel | null>(null);
const existingReview = ref<TeamEffectivenessReviewApiModel | null>(null);

const props = __props;

const route = useRoute();
const router = useRouter();

const teamId = computed(() => getTeamEffectivenessReportTeamId(route));
const reviewId = computed(() => getTeamEffectivenessReportReviewId(route));
const teamName = computed(() => {
  if (existingReview.value) {
    return existingReview.value.subjectTeamDetails.name;
  }

  return newReviewTeamDetails.value ? newReviewTeamDetails.value.name : "";
});

const sharingUrlDescription = computed(() =>
  !teamName.value ? "" : `Team Effectiveness Report For ${teamName.value}`,
);
const sharingReportType = computed(() =>
  reviewId.value ? "SpecificTeamEffectivenessReport" : "LatestTeamEffectivenessReport",
);
const sharingEntityId = computed(() => {
  if (!existingReview.value) {
    return "";
  }

  return sharingReportType.value === "SpecificTeamEffectivenessReport"
    ? existingReview.value.id
    : existingReview.value.subjectTeamId;
});

const canShare = computed(() => !!existingReview.value);
const questionnaireUrl = computed(() => `/team/effectivenessquestionnaire/${reviewId.value}`);
const terHighlightsUrl = computed(() => `/team/effectiveness/${teamId.value}`);
const reportDate = computed(() => {
  if (!existingReview.value || existingReview.value.questionnaires.length === 0) {
    return "";
  }

  return existingReview.value.completedDate
    ? moment(existingReview.value.completedDate).format("D MMMM YYYY")
    : moment([...existingReview.value.questionnaires].reverse()[0].completedDate).format(
        "D MMMM YYYY",
      );
});

const titleHtml = computed(() => {
  const cmsVariableOverrides = {};
  cmsVariableOverrides[cmsContentMap.variableNames.teamName] = teamName.value;
  return cms.asHtml((props.doc?.data as CmsResourceData)?.title, cmsVariableOverrides);
});

function getTeamDetails(): Promise<TeamApiModel> {
  return axios.get(`/api/teams/${teamId.value}`).then((resp) => {
    const data = resp.data as TeamApiModel;
    return data;
  });
}

onMounted(async () => {
  if (!teamId.value && !reviewId.value) {
    error.value = "This report could not be found.";
    return;
  }

  const reportModel = await getTeamEffectivenessReportFlexible(reviewId.value, teamId.value);
  if (reportModel == null) {
    error.value =
      "There was a problem getting your report. Please try refreshing the page, and if that doesn't work, you can contact us at support@gyreteams.com";
  } else {
    if (reportModel.review.questionnaires.length < 2) {
      await router.push("/NotFound");
    }

    existingReview.value = reportModel.review;
    needsToCompleteQuestionnaireFirst.value = reportModel.status === "ShouldCompleteQuestionnaire";
    needsToStartReviewFirst.value = reportModel.status === "ShouldStartReview";
    showReport.value = !!reportModel.review && reportModel.status === "ReportAvailable";
    error.value =
      reportModel.status === "ReportNotAvailable"
        ? "The report you requested does not exist, or is not currently available to you"
        : "";
    if (!existingReview.value && needsToStartReviewFirst.value) {
      newReviewTeamDetails.value = await getTeamDetails();
    }
    if (showReport.value) {
      if (!props.doc) {
        reportDoc.value = await cms.getByUid(
          CmsDocumentTypes.CmsReport,
          cmsContentMap.teamEffectiveness.reportUid,
        );
      } else {
        reportDoc.value = props.doc;
      }
    }
  }

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
          : (showReport.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", {
                        innerHTML: titleHtml.value,
                        class: "report-title"
                      }, null, 8, _hoisted_8),
                      _hoisted_9,
                      _createElementVNode("p", _hoisted_10, _toDisplayString(reportDate.value), 1),
                      _hoisted_11
                    ])
                  ]),
                  (canShare.value)
                    ? (_openBlock(), _createBlock(ShareButton, {
                        key: 0,
                        reportType: sharingReportType.value,
                        reportEntityId: sharingEntityId.value,
                        urlDescription: sharingUrlDescription.value
                      }, null, 8, ["reportType", "reportEntityId", "urlDescription"]))
                    : _createCommentVNode("", true)
                ]),
                (reportDoc.value)
                  ? (_openBlock(), _createBlock(CmsTextPage, {
                      key: 0,
                      doc: reportDoc.value,
                      context: { review: existingReview.value }
                    }, null, 8, ["doc", "context"]))
                  : _createCommentVNode("", true)
              ]))
            : (needsToCompleteQuestionnaireFirst.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h3", _hoisted_15, " You haven’t completed a Team Effectiveness Questionnaire on '" + _toDisplayString(teamName.value) + "' as part of this review yet. ", 1),
                      _hoisted_16
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("a", {
                        class: "btn btn-primary btn-lg",
                        href: questionnaireUrl.value
                      }, "Complete Questionnaire", 8, _hoisted_19)
                    ])
                  ]),
                  _hoisted_20
                ], 64))
              : (needsToStartReviewFirst.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("h3", _hoisted_24, [
                          _createTextVNode(" Your team, "),
                          _createElementVNode("b", null, _toDisplayString(teamName.value), 1),
                          _createTextVNode(", doesn't have a Team Effectiveness Review in progress. ")
                        ]),
                        _hoisted_25
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("a", {
                          class: "btn btn-primary btn-lg",
                          href: terHighlightsUrl.value
                        }, "Go to Team Effectiveness", 8, _hoisted_28)
                      ])
                    ]),
                    _hoisted_29
                  ], 64))
                : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})